import React, { useRef } from "react";
import { Icon } from "@ff-os/shared-react/components/icons/Icon";
import classNames from "classnames";
import { useMemoizedPhoto } from "../../memoizations/_redux-memoization";
import { PhotoPrintQuantity } from "../_desktop/photo-print/PhotoPrintQuantity";
import { PhotoPrintFrame } from "../photo-print/PhotoPrintFrame";
import styles from "./AccessoryPrintFrame.module.scss";

type AccessoryPrintFrameProps = {
  id: string;
  className?: string;
  selectedIds: string[];
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
};

const AccessoryPrintFrameComponent = ({ id, className, selectedIds, setSelectedIds }: AccessoryPrintFrameProps) => {

    const photo = useMemoizedPhoto(id);

    const photoRef = useRef<HTMLImageElement>(null);

    const isInSelectedIds = selectedIds.includes(id);

    const selectClasses = classNames(styles.selectFrame, {
        [styles.selected]: isInSelectedIds
    });

    const toggleSelectPhoto = () => {
        setSelectedIds(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id)
                : [...prev, id]
        );
    }

    return (
        <div className={classNames(styles.container, className)}>
            <div className={`${selectClasses} cursor-pointer`} onClick={toggleSelectPhoto}>
                <PhotoPrintFrame
                    photoId={id}
                    ref={photoRef}
                    className='cursor-pointer'
                    disabled={photo.status === 'error'}>
                </PhotoPrintFrame>
                <div className={styles.redIconContainer}>
                     <Icon type='general-ui-checkmark' size="small" strokeWidth={3} className={styles.icon} />
                </div>
            </div>

            {photo.status !== 'error' && (
                <PhotoPrintQuantity className={styles.input} photoId={id} />
            )}
        </div>
    );
};

export const AccessoryPrintFrame = React.memo(AccessoryPrintFrameComponent);